// extracted by mini-css-extract-plugin
module.exports = {"md":"gifts-list-entry-slide_md_EGJT8","ios":"gifts-list-entry-slide_ios_1N7Xk","slide":"gifts-list-entry-slide_slide_2KvPQ","content":"gifts-list-entry-slide_content_1MNBU"};